import {
  Notification,
  NotificationListResponse,
  UnreadCountResponse,
} from "@/types/notification";
import { fetchWithAuth } from "./client";

export const notificationsApi = {
  list: async (
    page: number = 1,
    pageSize: number = 20,
    unreadOnly: boolean = false
  ): Promise<NotificationListResponse> => {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
      unread_only: unreadOnly.toString(),
    });
    return fetchWithAuth(`/api/v1/notifications?${params}`);
  },

  getUnreadCount: async (): Promise<UnreadCountResponse> => {
    return fetchWithAuth("/api/v1/notifications/unread-count");
  },

  markAsRead: async (notificationId: string): Promise<Notification> => {
    return fetchWithAuth(`/api/v1/notifications/${notificationId}/read`, {
      method: "PUT",
    });
  },

  markAllAsRead: async (): Promise<{ message: string; count: number }> => {
    return fetchWithAuth("/api/v1/notifications/read-all", {
      method: "PUT",
    });
  },

  delete: async (notificationId: string): Promise<void> => {
    return fetchWithAuth(`/api/v1/notifications/${notificationId}`, {
      method: "DELETE",
    });
  },
};
